import React from 'react';
import { Switch } from 'react-router-dom';
import HomeLandingPage from 'src/components/selfService/features/Home/HomeLandingPage';
import AccountPage from 'src/components/Account/Account';
import { GroupDetails } from 'src/components/People/Groups/GroupDetails';
import PeopleLandingPage from 'src/components/People/PeopleLandingPage';
import OrderHistoryPage from 'src/components/selfService/features/OrderHistory/OrderHistory';
import OrderReceiptPage from 'src/components/selfService/features/OrderHistory/OrderReceipt';
import LineOfCreditLandingPage from 'src/components/selfService/features/LineOfCredit/LineOfCreditLanding';
import LineOfCreditDetailsPage from 'src/components/selfService/features/LineOfCredit/details/LineOfCreditDetails';
import withLayout from 'src/components/AppRoutes/SelfService/withLayout';
import WrappedRoute from 'src/components/AppRoutes/WrappedRoute';

export const SelfServiceRoutes = (): JSX.Element => {
  const Home = withLayout(HomeLandingPage);
  const People = withLayout(PeopleLandingPage);
  const OrderHistory = withLayout(OrderHistoryPage);
  const Group = withLayout(GroupDetails);
  const LineOfCreditDetails = withLayout(LineOfCreditDetailsPage);
  const LineOfCreditLanding = withLayout(LineOfCreditLandingPage);
  const OrderReceipt = withLayout(OrderReceiptPage);
  const Account = withLayout(AccountPage);

  return (
    <Switch>
      <WrappedRoute
        exact
        path="/corporate/management/:corpid/home"
        component={() => <Home title="Home" />}
      />
      <WrappedRoute
        exact
        path="/corporate/management/:corpid/people"
        component={() => <People title="People" />}
      />
      <WrappedRoute
        exact
        path="/corporate/management/:corpid/orderHistory"
        component={() => <OrderHistory title="Order activity" />}
      />

      <WrappedRoute
        exact
        path="/corporate/management/:corpid/groups/:groupId"
        component={() => <Group title="Group details" />}
      />
      <WrappedRoute
        exact
        path="/corporate/management/:corpid/lineOfCredit/:locId"
        component={() => <LineOfCreditDetails title="Line of credit details" />}
      />
      <WrappedRoute
        exact
        path="/corporate/management/:corpid/lineOfCredit"
        component={() => <LineOfCreditLanding title="Line of credit" />}
      />
      <WrappedRoute
        exact
        path="/corporate/management/:corpid/orderHistory/:orderId"
        component={() => <OrderReceipt title="Order receipt" />}
      />
      <WrappedRoute
        exact
        path="/corporate/management/:corpid/account"
        component={() => <Account title="Your account" />}
      />
    </Switch>
  );
};
